import { useTranslation } from 'next-i18next';
import { FC, useEffect, useRef } from 'react';

import { AuthEntryPoint } from '../../features/auth/types';
import { useAuthenticate } from '../../hooks/useAuthenticate';
import { useAuth } from '../../providers';
import { VideoPlayButton } from './VideoPlayButton';

interface Props {
  className?: string;
  label?: string;
  onPlay: () => void;
  title?: string;
  variant: 'light' | 'dark';
}

export const AuthenticatedPlayButton: FC<Props> = ({
  className,
  label,
  onPlay,
  title,
  variant,
}) => {
  const { t } = useTranslation('authentication');
  const { user } = useAuth();
  const { authenticateAndSubscribe } = useAuthenticate();

  // onFlowComplete fires when the auth modal closes, whether or not the user
  // signed in, so read the latest auth state through a ref to decide playback
  const userRef = useRef(user);
  useEffect(() => {
    userRef.current = user;
  }, [user]);

  return (
    <VideoPlayButton
      className={className}
      label={label}
      onClick={() => {
        if (user) {
          onPlay();
          return;
        }

        void authenticateAndSubscribe({
          analyticsProperties: {
            'button_location': 'inline video',
            'source': AuthEntryPoint.Video,
            'video title': title ?? '',
          },
          authScreenTitle: t('dynamicTitle.video'),
          onFlowComplete: () => {
            if (userRef.current) {
              onPlay();
            }
          },
          subscriptions: [],
        });
      }}
      variant={variant}
    />
  );
};
